/**
 * Vehicle transmission type values
 */
export enum VehicleTransmissionTypeEnum {
	MANUAL = 'manual',
	AUTOMATIC = 'automatic',
	CVT = 'cvt',
	OTHER = 'other',
}
